import React from 'react';
import { HashRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Footer from '../components/Layout/Footer';
import HeaderMain from '../components/Layout/Header';
import HomePage from '../components/Order/HomePage';
import Product from '../components/Order/Products/Product';
import { routesConfig } from '../util/util';
import SinglePageCheckout from '../components/Order/SinglePageCheckout/SinglePageCheckout';
import ThankYou from '../components/Order/ThankYou';
import VasPrdoduct from '../components/Order/Checkout/VasProducts';
import VasStatic from '../components/Order/VasStatic';
import NonServiceable from '../components/Order/NonServiceable';
import { isInvocaTestMode, ensureInvocaTestModeParam } from '../util/invocaTestMode';
import { useSinglePageCheckout } from '../hooks/order';

const InvocaRunner = () => {
  const location = useLocation();

  // Ensure Invoca test mode param persists on every route change
  React.useEffect(() => {
    if (isInvocaTestMode()) {
      ensureInvocaTestModeParam();
    }
  }, [location]);

  // Invoca is deliberately NOT re-run per route change. Re-running re-leases the
  // pool number, which would change the displayed number mid session and split
  // call attribution. Acquisition is handled by useTrackedTfn, which only re-runs
  // when the base number has no assignment yet. (The previous `PNAPI.run()` here
  // was a no-op anyway - `run()` does nothing once the tag's initial pass has
  // completed - so nothing is lost by dropping it.)

  return null;
};

// ELNKWEB-3332. While the call centre is taking calls the single-page checkout is off-limits, so
// a customer who reaches /checkout then (bookmark, back button) is sent to the products page and
// its call-in experience. Decided once, on arrival: opening time must not pull a customer out of
// a checkout they started after hours.
const CheckoutRoute = () => {
  const isSinglePageCheckout = useSinglePageCheckout();
  const [allowSinglePageCheckout] = React.useState(isSinglePageCheckout);

  return allowSinglePageCheckout ? <SinglePageCheckout /> : <Navigate to={routesConfig.products} replace />;
};

const AppRoutes = (props) => {
  return (
    <>
      <HashRouter>
        <InvocaRunner />
        <HeaderMain />
        <Routes>
          <Route exact {...props} path={'/'} element={<HomePage {...props} />} />
          <Route exact {...props} path={routesConfig.products} element={<Product />} />
          <Route exact {...props} path={routesConfig.checkout} element={<CheckoutRoute />} />
          <Route exact {...props} path={routesConfig.reviewOrder} element={<Navigate to={routesConfig.checkout} replace />} />
          <Route exact {...props} path={routesConfig.thanks} element={<ThankYou />} />
          <Route exact {...props} path={routesConfig.vasPage} element={<VasPrdoduct />} />
          <Route exact {...props} path={routesConfig.vas} element={<VasStatic />} />
          <Route exact {...props} path={routesConfig.nonServiceable} element={<NonServiceable />} />
        </Routes>
        <Footer />
      </HashRouter>
    </>
  );
};
export default AppRoutes;
